import React from "react";
import { Box, Card, CardMedia, Chip } from "@material-ui/core";
import { AiOutlineHeart } from "react-icons/ai";


import RatingCircle from "./Rating";

const PlaceDetails = ({ place, selected, refProp }) => {
  if (selected)
    refProp?.current?.scrollIntoView({ behavior: "smooth", block: "start" });

  return (
    <div elevation={6} className="flex h-40">
      {/* <div className="w-[30%]"> */}
      <Card className="relative w-[30%]">
        <div className="absolute z-[50] ml-[8.5rem] mt-2 text-gray-light text-right cursor-pointer rounded-[10rem] bg-white p-1 hover:bg-red-400">
          {/* <span className="text-black">&#x2764;</span> */}
          <AiOutlineHeart />
        </div>

        <CardMedia
          className="w-full h-full"
          component="img"
          image={
            place?.photo?.images?.large?.url
              ? place.photo.images.large.url
              : "https://media-cdn.tripadvisor.com/media/photo-s/11/e8/ee/a8/chaiyum-special-masala.jpg&quot"
          }
          title={place.name}
        />
      </Card>
      {/* </div> */}

      <div className="w-[70%] ml-4">
        <div gutterBottom variant="h6" className="text-xl mb-1 font-bold">
          {place.name}
        </div>
        <div className="flex ">
          <RatingCircle value={Number(place.rating)} />
          <div className="text-xs mb-3 -mt-1 font-normal text-gray-500 pl-4">
            {place.num_reviews}{" "}
          </div>
        </div>
        <Box className="flex justify-between mb-1">
          <div className="text-xs">Ranking{place.ranking}</div>
        </Box>
        {place?.awards?.map((award) => (
          <div
            key={award.display_name}
            className="flex justify-between items-center"
          >
            <img src={award.images.small} alt={award.display_name} />
            <div className="text-sm text-secondary">{award.display_name}</div>
          </div>
        ))}

        {place?.cuisine?.map(({ name }, index) => (
          <React.Fragment key={name}>
            {index === 0 && <h1>Cuisines</h1>}
            <Chip size="small" label={name} className="text-xs" />
          </React.Fragment>
        ))}

        {place?.subtype?.map(({ name }, index) => (
          <React.Fragment key={name}>
            {index === 0 && <h1>Points of Interest & Landmarks</h1>}
            <Chip key={name} size="small" label={name} className=" text-xs" />
          </React.Fragment>
        ))}
      </div>
    </div>
  );
};

export default PlaceDetails;
